import React from 'react';
import Alert from '@material-ui/lab/Alert';
import queryString from 'query-string';

/**
 * High-Order Component that checks if the URL has the necesarry query params
 * @param Component The Component to return in case the validation is sucessful
 */
export const withInit = <P extends object>(Component: React.ComponentType<P>) =>
  class WithInit extends React.Component<P> {
    hasCompanyKey = (search: string): boolean => {
      if (search.trim().length) {
        const parsed = queryString.parse(search);
        return typeof parsed.companyKey === 'string' && parsed.companyKey.trim().length > 0;
      } else {
        return false;
      }
    };

    render() {
      const search = window.location.search;
      if (this.hasCompanyKey(search)) {
        const { ...props } = this.props;
        return <Component {...(props as P)} />;
      } else {
        return (
          <div className="Init">
            <Alert severity="error">No Company key found.</Alert>
          </div>
        );
      }
    }
  };
